
export const config = {

  baseApiUrl: '/api',
  baseUrl: 'http://piinc.test/',
  language: 'en',
  dateFormat: 'DD MMM YYYY',
  dateTimeFormat: 'DD MMM YYYY HH:mm:ss',
  descriptionLength: 800,
  maintenance: false

}